module.exports = __webpack_public_path__ + "static/media/Marathahalli.6c4ad1bc.jpg";